import TagPicker from 'library/components/form/tag-picker';
import WishlistSwitch from 'library/components/form/wishlist-checkbox';
import useTagList from 'library/hooks/use-deferred-data/use-tag-list';
import Input from 'library/components/form/input';
import TextArea from 'library/components/form/textarea';
import {
  ButtonFileContainer, Icon, ButtonFile, FieldContainer,
} from './styles';

export default ({
  isCreate = false,
  isEditable = false,
  labelMaps,
  data,
  isAdditionalDataLoadDenied,
  modalFieldHandlers: {
    handleUploadModalOpen,
    handlePickCategoryModalOpen,
    handlePickStorageModalOpen,
    handlePickManufacturerModalOpen,
    handleAddToSetModalOpen,
    handleSearchByColorModalOpen,
  },
  disabledFields = [],
}) => {
  const {
    onQueryChange: onTagQueryChange, options: tagsOptions, labelMap, isLoading: isTagListLoading, nameMap,
  } = useTagList(
    false,
  );

  return (
    <FieldContainer>
      {
        isEditable && (
          <ButtonFileContainer>
            <ButtonFile onClick={handleUploadModalOpen}>
              <Icon className="icon-picture" />
              Add image from ...
            </ButtonFile>
          </ButtonFileContainer>
        )
      }
      {isEditable ? (
        <Input
          placeholder="Name this item (required)"
          iconClassName="icon-pencil"
          name="name"
          required={isCreate}
          readOnly={!isEditable}
        />
      ) : null}
      <Input
        placeholder="Select a category (required)"
        iconClassName="icon-category"
        name="category"
        formatterMap={labelMaps.categoryMap}
        required={isCreate}
        onClick={isEditable ? handlePickCategoryModalOpen : undefined}
        readOnly
      />
      <Input
        placeholder="Add to set"
        iconClassName="icon-set"
        name="sets"
        formatterMap={labelMaps.setMap}
        onClick={(isEditable && !disabledFields.includes('sets')) ? handleAddToSetModalOpen : undefined}
        readOnly={!isEditable}
        isSetField
      />
      <Input
        placeholder="Colors"
        iconClassName="icon-colors"
        name="colors"
        isColorField
        onClick={isEditable ? handleSearchByColorModalOpen : undefined}
        readOnly={!isEditable}
      />
      <Input
        type="number"
        placeholder="Quantity on hand"
        iconClassName="icon-layers"
        name="count"
        readOnly={!isEditable}
        min={0}
      />
      <TagPicker
        placeholder="Add tags"
        name="tags"
        options={tagsOptions}
        formatterMap={labelMap}
        nameMap={nameMap}
        readOnly={!isEditable}
        isLoading={isTagListLoading}
        defaultValue={data?.tags?.map((t) => t.id)}
        onQueryChange={onTagQueryChange}
      />
      <Input
        placeholder="Item is stored here"
        iconClassName="icon-drawer"
        name="storage"
        readOnly
        formatterMap={labelMaps.storageMap}
        onClick={isEditable ? handlePickStorageModalOpen : undefined}
      />
      <Input
        placeholder="Manufacturer"
        iconClassName="icon-manufacturer"
        name="manufacturer"
        formatterMap={labelMaps.manufacturerMap}
        readOnly
        onClick={isEditable ? handlePickManufacturerModalOpen : undefined}
      />
      <Input
        placeholder="Barcode"
        iconClassName="icon-barcode"
        name="barcode"
        readOnly={!isEditable}
      />
      <Input
        type="number"
        placeholder="Price"
        iconClassName="icon-price"
        name="price"
        readOnly={!isEditable}
      />
      <TextArea
        placeholder="Notes"
        iconClassName="icon-notes"
        name="note"
        readOnly={!isEditable}
        autoComplete="off"
        role="presentation"
      />
      {!isCreate && isEditable ? (
        <WishlistSwitch
          name="is_wishlisted"
          iconClassName="icon-heart"
        />
      ) : null}
    </FieldContainer>
  );
};
